<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <vs-table
          :max-items="descriptionItems[0]"
          pagination
          :data="itemModels"
          description
          search
          @selected="viewData"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("setup.label.ItemModel") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                @click="$router.push({ name: 'Create Item Model' })"
                size="small"
                >{{ $t("setup.label.CreateItemModel") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("setup.label.NetworkElement") }}</vs-th>
            <vs-th>{{ $t("setup.label.Model") }}</vs-th>
            <vs-th>{{ $t("setup.label.ItemType") }}</vs-th>
            <vs-th>{{ $t("setup.label.Make") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="ItemModel"
              v-for="(ItemModel, index) in data"
            >
              <vs-td :data="ItemModel.provisioningName">{{
                ItemModel.provisioningName
              }}</vs-td>
              <vs-td :data="ItemModel.model">{{ ItemModel.model }}</vs-td>
              <vs-td :data="ItemModel.itemType">{{ ItemModel.itemType }}</vs-td>
              <vs-td :data="ItemModel.make">{{ ItemModel.make }}</vs-td>
              <!-- <vs-td :data="entity.externalId">{{ entity.externalId }}</vs-td>
                <vs-td :data="entity.parentName">{{ entity.parentName }}</vs-td>
                <vs-td :data="entity.officeType">{{ entity.officeType }}</vs-td>
                <vs-td :data="getDate(entity.openingDate)">{{
                  getDate(entity.openingDate)
                }}</vs-td> -->
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('inventory.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editData(ItemModel.id)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('inventory.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      editJobsPopup = true;
                      delId = ItemModel.id;
                    "
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('inventory.label.DeleteItemModel')"
          :active.sync="editJobsPopup"
          class="popup-close small-popup"
        >
          <div class="center">
            <img src="@/assets/images/pages/delete.svg" />
            <div class="success-msg">
              {{ $t("system.label.areYouSureDelete") }}
            </div>
          </div>

          <div class="center">
            <span class="p-2">
              <vs-button type="border" @click="editJobsPopup = false">{{
                $t("system.label.cancel")
              }}</vs-button></span
            >

            <span class="p-2">
              <vs-button @click="removeItemModel(delId)">{{
                $t("setup.label.Ok")
              }}</vs-button>
            </span>
          </div>
          <div style="height: 20px"></div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      descriptionItems: [5, 10, 15],
      editJobsPopup: false,
      delId: 0,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      itemModels: (state) => state.itemModel.itemModels,
    }),
  },
  methods: {
    async getItemModelList() {
      this.loading = true;
      try {
        await this.$store.dispatch("itemModel/fetchItemModelList");
      } catch (e) {
        this.$toasted.error(e.message);
      }
      this.loading = false;
    },
    editData(id) {
      this.$router.push({ name: "Edit Item Model", params: { id: id } });
    },
    async removeItemModel(id) {
      try {
        await this.$store.dispatch("itemModel/deleteItemModelAction", id);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Item Model Successfully Deleted",
          type: "success",
        });
        this.editJobsPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    viewData(ItemModel) {
      this.$router.push({ name: "View Item Model", params: { id: ItemModel.id } });
    },
    // viewData(item) {
    //   this.$router.push({ name: "View Supplier", params: { id: item.id } });
    // },
  },
  mounted() {
    this.getItemModelList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.list-heading {
  font-size: 1.8rem !important;
}
</style>
